import React from 'react';
import PropTypes from 'prop-types';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import MobileModalTrigger from '../../Groups/Modals/MobileModalTrigger/MobileModalTrigger';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';

import './MobileWandTrigger.scss';

export default class MobileWandTrigger extends React.PureComponent {
    handleClick = (context) => () => {
        if (context.isLoggedIn()) {
            EmitMetric({
                misc_event_count: 1,
                misc_event_type: 'mobile-plus-click',
            });
            context.modalTrigger('MobileMenuModal', {
                location: this.props.location,
                currentTopic: this.props.currentTopic,
            });
        }
    };

    render() {
        const injectedTransforms = {
            default: '',
        };
        const imagePath = buildImagePath(
            '/v1567625408/SVGs/sticky_button_with_more.svg',
            'default',
            injectedTransforms
        );
        return (
            <div className="component-CallToAction-MobileWandTrigger">
                <PageConsumer>
                    {(context) =>
                        context.wrapAuth(
                            'CreateContent',
                            <div
                                tabIndex={0}
                                role="button"
                                onClick={this.handleClick(context)}
                                onKeyPress={this.handleClick(context)}
                                style={{
                                    display: context.isLoggedIn()
                                        ? 'inline-block'
                                        : 'none',
                                }}
                            >
                                <img
                                    className="wand-trigger"
                                    src={imagePath}
                                    alt="wand-button"
                                />
                            </div>,
                            { login_trigger: 'create-content' }
                        )
                    }
                </PageConsumer>
            </div>
        );
    }
}

MobileModalTrigger.defaultProps = {
    location: 'feed',
};

MobileModalTrigger.propTypes = {
    location: PropTypes.string,
};
